module.exports = __webpack_public_path__ + "static/media/developers_overview_4.9853c295.png";